export { default } from "../quiz/quiz.js"
